export const STRING = 'String';
//# sourceMappingURL=STRING.js.map